// @flow
'use strict';

import * as React from 'react';

import type { ICofinsStQtde } from '../../../../../types_imposto';

import RowDetalhes from '../../../../../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../../../../../common/detalhes_documento/column_detalhes';

type CofinsStQtdeProps = {
  item : ICofinsStQtde,
};

export default function CofinsStQtde({ item } : CofinsStQtdeProps) {
  return (
      <RowDetalhes data={ item }>
        <ColumnDetalhes field="qtdVendida" width="25%">Quantidade Vendida</ColumnDetalhes>
        <ColumnDetalhes field="valorAliquota" type="moeda" width="25%">Alíquota da COFINS</ColumnDetalhes>
        <ColumnDetalhes field="valorCofins" type="moeda" width="25%">Valor da COFINS</ColumnDetalhes>
      </RowDetalhes>
  );
}
